import { BrowserRouter as Router } from 'react-router-dom';
import { AppProviders, LanguageProviderWrapper } from './providers/AppProviders';
import { AppRoutes } from './routes';

/**
 * Main Application Component
 * 
 * This is the root component of the application.
 * It sets up routing and provides all necessary context providers.
 * 
 * The application structure has been refactored for better maintainability:
 * - Routes are organized in `routes/` directory by domain/feature
 * - Route wrapper components are in `routes/components/`
 * - Provider setup is in `providers/AppProviders.tsx`
 */
function App() {
  return (
    <AppProviders>
      <Router>
        <LanguageProviderWrapper>
          <div className="App">
            <AppRoutes />
          </div>
        </LanguageProviderWrapper>
      </Router>
    </AppProviders>
  );
}

export default App;
